import { LegacyTvChannelPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const getChannelFragment = (
    channel: LegacyTvChannelPlayerBaseInfoContent | null | undefined
) => channel ?? null;
